import { ScopeHooks } from "sockapi/scope-specs";
import { getPuzzleScopeIdComponents } from "sockapi/scope-specs-util";
import { PuzzleContent } from "sockapi/scope-specs/puzzle-content-spec";
import { ScopeType } from "sockapi/scope-types";
import { ScopePuzzleIdentifier } from "sockapi/scopes";
import { PuzzleMetadata, PuzzleType } from "sockapi/puzzle-data";

export const doesSolutionExist = (puzData: PuzzleMetadata) => {
  return puzData.type === PuzzleType.PUZZLE;
};

// Patchable from registerGlobals
export const SOLUTION_CONFIG = {
  isSolutionPageAvailable: (
    puzName: string,
    isSolved: boolean,
    isFinished: boolean
  ) => isSolved && isFinished,
};

export const isSolutionPageAvailable = (
  puzName: string,
  isSolved: boolean,
  isFinished: boolean
) => {
  return SOLUTION_CONFIG.isSolutionPageAvailable(puzName, isSolved, isFinished);
};

export type SolutionContentScopeSpec = {
  identifier: ScopePuzzleIdentifier;
  state: PuzzleContent & {
    answer: string | null;
    authors?: string[];
    otherCredits?: string;
  };
};

export const solutionContentScopeHooks: ScopeHooks<ScopeType.SOLUTION_CONTENT> =
  {
    identityFunc: (scope) => scope,
    getIdComponents: getPuzzleScopeIdComponents,
  };
